import { useEffect, useMemo, useRef } from "react";
import { useEvidenceSocketStore } from "../store/admin/evidenceSocketStore";
import type { EvidenceFilter } from "../evidenceSocket";

export const useEvidenceSubscription = (filter: EvidenceFilter) => {
  const connect = useEvidenceSocketStore((state) => state.connect);
  const disconnect = useEvidenceSocketStore((state) => state.disconnect);
  const updateSubscription = useEvidenceSocketStore(
    (state) => state.updateSubscription
  );
  const isConnected = useEvidenceSocketStore((state) => state.isConnected);
  const error = useEvidenceSocketStore((state) => state.error);
  const joinedRooms = useEvidenceSocketStore((state) => state.joinedRooms);

  const filterKey = useMemo(() => JSON.stringify(filter), [filter]);
  const filterRef = useRef(filter);
  filterRef.current = filter;

  const hasMounted = useRef(false);

  useEffect(() => {
    connect(filterRef.current);

    return () => {
      disconnect();
    };
  }, [connect, disconnect]);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }
    updateSubscription(filterRef.current);
  }, [filterKey, updateSubscription]);

  return {
    isConnected,
    error,
    joinedRooms,
  };
};

export default useEvidenceSubscription;
